export default __webpack_public_path__ + "static/media/Luke.34ef3340.jpg";